import React from 'react'

function CardInfo({ title, description, children }) {
  return (
    <article className='p-4 rounded-lg flex flex-col gap-2 items-start justify-center outline outline-2 outline-primario group shadow-custom-first'>
        <span className='p-4 rounded-full text-yellow-1 bg-secundario group-hover:bg-yellow-1 group-hover:text-primario trasalition-all duration-200 ease-in-out'>
            {children}

        </span>
        <h3 className='text-xl text-primario font-bold'>{title}</h3>
        <p className='text-lg text-gray-500'>
            {description}
        </p>
    </article>
  )
}

export default CardInfo